import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { QueryClientProvider } from 'react-query';
import { AppQueryClient } from './services/clients/query-client';
import "./index.css"

ReactDOM.render(
  <QueryClientProvider client={AppQueryClient}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </QueryClientProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();